module.exports = __webpack_public_path__ + "assets/ProfissionalDoutorado.ba1ccadd31d2da7df11b4fff1bbc219a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/ProfissionalDoutorado.png
 ** module id = 483
 ** module chunks = 0
 **/